import { TOTAL_UPLOAD_LIMIT_BULK } from '../config/fileUploadLimit.ts';
import { BULK_UPLOAD_LIMIT } from '../config/limitForBulkUpload.ts';
import type { Doc } from '../hooks/useUploadReducer.ts';
import type { GoogleDrivePickerDoc } from '../services/GoogleAPIs/GoogleDrivePicker.ts';
import type { OneDriveFileType } from '../services/OneDriveAPIs/OneDriveTypes.ts';

export const isBulkLengthLimitReached = (
	documents: (GoogleDrivePickerDoc | File | OneDriveFileType)[],
): boolean => documents.length > BULK_UPLOAD_LIMIT;

export const getBulkTotalSize = (documents: (Doc | File | null | OneDriveFileType)[]): number => {
	return documents.reduce((acc, doc) => {
		if (doc && doc.size) return acc + doc.size;
		return acc;
	}, 0);
};

export const isBulkTotalSizeLimitReached = (
	documents: (Doc | File | null | OneDriveFileType)[],
): boolean => {
	return getBulkTotalSize(documents) > TOTAL_UPLOAD_LIMIT_BULK;
};
